export const YOUTUBE_TERMS_URL = 'https://www.youtube.com/t/terms'
export const GOOGLE_PRIVACY_URL = 'https://www.google.com/policies/privacy'
export const GOOGLE_SECURITY_SETTINGS_URL = 'https://security.google.com/settings/security/permissions'
export const PRIVACY_POLICY_URL = 'https://www.stagepilot.com/legal/privacy'
export const TERMS_OF_SERVICE_URL = 'https://www.stagepilot.com/legal/terms-of-use'

export const SOCIAL_INSTAGRAM_URL: string = 'https://www.instagram.com/thestagepilot/'
export const SOCIAL_LINKEDIN_URL: string = 'https://www.linkedin.com/company/stagepilot'

export const CONTACT_EMAIL: string = 'support@stagepilot.com'

export const PUBLIC_CONTACT_URL = 'https://stagepilot.com/contact'

export interface AccountDeletionContact {
  href: string
  label: string
  external: boolean
  isEmail: boolean
}

export const accountDeletionContact = (): AccountDeletionContact =>
  ({ href: PUBLIC_CONTACT_URL, label: 'contact us', external: true, isEmail: false })
